import { AnimationControls, HTMLMotionProps, motion } from "framer-motion";
import { useLayoutEffect, useState } from "react";

type SkeletonProps = HTMLMotionProps<"div"> & {
  height: number | string;
  borderRadius: number | string;
  color: string;
  highlightColor: string;
  delay?: number;
};
const Skeleton = ({
  height,
  borderRadius,
  color,
  highlightColor,
  delay,
  ...props
}: SkeletonProps) => {
  const [width, setWidth] = useState(0);
  const [parentRef, setParentRef] = useState<HTMLDivElement | null>(null);
  const gradient = `linear-gradient(90deg, ${color} 0%, ${highlightColor} 50%, ${color} 100%)`;

  useLayoutEffect(() => {
    if (parentRef) {
      setWidth(parentRef.offsetWidth);
    }
  }, [parentRef]);

  return (
    <motion.div
      style={{
        width: "100%",
        height,
        borderRadius,
        position: "relative",
        overflow: "hidden",
      }}
      ref={setParentRef}
    >
      <motion.div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          left: 0,
          top: 0,
          background: gradient,
          backgroundSize: "100% 100%",
        }}
        animate={{
          x: [-width, width],
          transition: {
            repeat: Infinity,
            duration: 1.2,
            ease: "linear",
            delay,
          },
        }}
      />
    </motion.div>
  );
};

export default Skeleton;
